import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import './Modal.scss';

export default class ModalComponent extends Component {
    render() {
        const {
            open,
            onClose,
            children,
            size = "small"
        } = this.props;
        
        return (
            <Modal
                open={open}
                onClose={onClose}
                size={size}
            >
                {children}
            </Modal>
        );
    }
}